import React, { useState, useEffect } from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft } = FiIcons;

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const logoUrl = "https://i.postimg.cc/mgsj3n1B/Profit-Lense-Ai-removebg-preview-1-e1761938877150-re14vm2sctdm5afac5mt1eumkxkt6ihxc8sqlln5a0.png";

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b ${
        scrolled 
          ? 'bg-[#0A0E17]/80 backdrop-blur-lg border-gray-800/80 shadow-lg shadow-black/20 py-4' 
          : 'bg-transparent border-transparent py-6'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-between items-center">
        <a 
          href="https://profitlense.ai" 
          className="flex items-center gap-3 group transition-transform hover:scale-[1.02] active:scale-[0.98]"
        >
          <div className="relative flex items-center justify-center w-12 h-12">
            <img 
              src={logoUrl} 
              alt="ProfitLense.AI Logo" 
              className="w-full h-full object-contain filter drop-shadow-[0_0_8px_rgba(59,130,246,0.3)]"
            />
          </div>
          <span className="text-xl font-bold tracking-tight text-white flex items-center">
            ProfitLense<span className="text-blue-400">.AI</span>
          </span>
        </a>

        <a 
          href="https://profitlense.ai"
          className="hidden sm:flex items-center gap-2 text-sm font-medium text-gray-400 hover:text-white transition-colors bg-white/5 hover:bg-white/10 px-4 py-2 rounded-full border border-white/5 hover:border-white/10"
        >
          <SafeIcon icon={FiArrowLeft} />
          Back to Home
        </a>
      </div>
    </nav>
  );
}